import axios, { AxiosError } from 'axios';
import { Environment } from '../../../../environment';
import { Api } from '../../axios-config';

export interface IListagemValeresumo {
    idvale:string,
    mes:string,
    periodo:string,
    historico:string,
    valor:number,
    financeiro:boolean,
    status:string,
    parcela:string,
    tipodesconto:string,
}
export interface IListagemValesgrafico {
    mes:number,
    periodo:string,
    total:number, 
}

type TotalCount = {
    detalhes: IListagemValeresumo[];
    grafico: IListagemValesgrafico[];
    totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, idfun: string,  ano: string): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/valesresumo?page=${page}&limit=${Environment.LIMITE_DE_LINHAS1}&idfun=${idfun}&ano=${ano}`;
    const { data, headers } = await Api.get(urlRelativa);  
    if ( data) {
      const [grafico, detalhes] = data;       
      return {
        grafico,
        detalhes,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS1),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const ValeresumoService = {
  getAll
};